import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SymbolIdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class TombOfNefertitiSymbolIdleAnimationController extends SymbolIdleAnimationController {

    private _animItems: PIXI.Sprite[] = [];
    private _layer: PIXI.Container;

    private _activeItem: PIXI.Sprite = new PIXI.Sprite();

    private _nextMode: string = "";

    private _isAllowed: boolean = true;

    constructor() {
        super({
            minInterval: 3,
            maxInterval: 5
        });

        let item: PIXI.Sprite,
            pos: number[];

        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.IDLE.name);
        for (let i: number = 0; i < TombOfNefertitiGameConfig.instance.REELS_NUM; ++i) {
            pos = Helper.getSymbolPositions(i, 0);

            item = new PIXI.Sprite();

            item.position.set(pos[0], pos[1]);

            item.anchor.set(0.5);
            item.visible = false;

            this._animItems[i] = item;

            this._layer.addChild(item);
        }
    }

    protected addEventListeners(): void {
        super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this._nextMode = event.params[0].nextMode);
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event: GameEvent) => this._nextMode = event.params[0].newMode);
        EventHandler.addEventListener(this, SpinEvent.START, () => this._isAllowed = false);
        EventHandler.addEventListener(this, WinPresentationEvent.WIN_PRESENTATIONS_STARTED, () => this._isAllowed = true);
    }

    protected playIdleAnimation(): void {
        if (!this._isAllowed || !this._hasSymbolIdle || this._nextMode.indexOf("FREESPIN") !== -1) {
            this._isAllowed = false;
            return;
        }

        const reelId: number = MathHelper.randomNumberInRange(0, TombOfNefertitiGameConfig.instance.REELS_NUM - 1);
        const symbol = Reels.getSymbol(reelId, 0);

        if (symbol) {
            let symName: string = symbol.symName,
                item: PIXI.Sprite;

            if (!UserAgent.isMobile && symName.indexOf("L") === -1) {
                this.playSymbolIdleAnimation(symbol);
            }

            if (symName.indexOf("L") !== -1) {
                this.playSymbolIdleAnimation(symbol);

                const duration: number = 0.5;

                item = this._animItems[reelId];
                item.visible = true;

                item.texture = GameResources.getTextures(`${symName}/${symName}-H`)[0];
                item.alpha = 0;

                TweenLite.to(item, duration, {
                    alpha: 1,
                    onComplete: () => TweenLite.to(item, duration, {alpha: 0})
                });

                this._activeItem = item;
            }
        }
    }

    protected stopIdleAnimation(): void {
        super.stopIdleAnimation && super.stopIdleAnimation();

        this._activeItem.visible = false;

        this._isAllowed = false;
    }
}